import React, { useCallback, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { getCalloutList, sortListWithPriority } from './helper';

export const CalloutStoreContext = React.createContext({});

export const CalloutStoreProvider = ({ calloutListConfig, children }) => {
  const [queue, setQueue] = useState(getCalloutList(calloutListConfig));

  const next = useCallback((name, justSkipThisTime = false) => {
    const firstName = (queue[0] && queue[0].name) || '';
    if (name && firstName !== name) {
      return;
    }
    let queueClone;
    if (!justSkipThisTime) {
      queue.shift();
      queueClone = [...queue];
      setQueue(queueClone);
    } else if (queue.length > 0) {
      // just skip this time, add to the queue again. May display later.
      const firstItem = queue.shift();
      queueClone = [queue[0], ...sortListWithPriority(queue.slice(1), firstItem)];
      setQueue(queueClone);
    }
  }, [queue]);

  const contextVal = useMemo(() => ({
    queue,
    next,
  }), [next, queue]);

  return (
    <CalloutStoreContext.Provider value={contextVal}>
      {children}
    </CalloutStoreContext.Provider>
  );
};

CalloutStoreProvider.propTypes = {
  calloutListConfig: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  children: PropTypes.node.isRequired,
};

export const useCalloutStore = () => useContext(CalloutStoreContext);


// export class CalloutService {
//   constructor() {
//     this.queue = [];
//   }

//   subscribe({ name, component, props }) {
//     const calloutEntity = new CalloutEntity({ name, component, props });
//     this.queue.push(calloutEntity);
//   }

//   next() {
//     this.queue.shift();
//   }
// }
